import { IBaseDialogStoreState, BaseDialogStoreState } from './baseDialogStoreState';
import * as StM from '../../store';

export interface IEditPackageDialogStoreState extends IBaseDialogStoreState {
    id?: number;
}

export class EditPackageDialogStoreState extends BaseDialogStoreState {
    id?: number;
    constructor() {
        super();
    }
}